module.exports = __webpack_public_path__ + "static/Gotham-Ultra-9ec16ccd6058e745d7c2266e1c425e24.woff";